import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  handleClose: () => void;
  isLoading: boolean;
  handleCloseAndOk: () => void;
}

export const DeleteRecordsDialog: FC<Props> = ({ open, handleClose, isLoading, handleCloseAndOk }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('dashboard.assets.records.deleterecords.headline')}</DialogTitle>
      <DialogContent>
        <Typography>{t('dashboard.assets.records.deleterecords.message')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button type="button" color="inherit" onClick={handleClose}>
          {t('dashboard.assets.records.deleterecords.cancel')}
        </Button>
        <LoadingButton loading={isLoading} variant="contained" disableElevation color="error" onClick={handleCloseAndOk}>
          {t('dashboard.assets.records.deleterecords.ok')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
